import React, { useMemo } from 'react';
import { gql } from '@soundxyz/gql-string';
import { ReleaseCard } from '@components/SongCards/ReleasesSongCard';
import { CarouselWithHeader } from '@components/main-components/carousel/HeaderCarousel';
import type { FragmentType } from '@graphql/reactQuery';
import { CollectorAppearsOnFragmentDoc, getFragment } from '@graphql/reactQuery';
import { formatProfileHeader } from '@utils/helpers';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment CollectorAppearsOn on User {
    id
    creditAllocations {
      id
      creditSplit {
        id
        mintedReleases {
          id
          ...ReleasesCard
        }
      }
    }
    ...CarouselUserInfo
  }
`);

export const CollectorAppearsOnCarousel = ({
  userFrag,
}: {
  userFrag: FragmentType<CollectorAppearsOnFragmentDoc>;
}) => {
  const user = getFragment(CollectorAppearsOnFragmentDoc, userFrag);

  const creditAllocations = user?.creditAllocations;

  const releasesSlides = useMemo(() => {
    const releases = creditAllocations.flatMap(ca => ca.creditSplit.mintedReleases) || [];
    return releases?.map(release => ({
      id: release.id,
      slide: (
        <ReleaseCard
          data={release}
          playlist={{
            type: 'HOLDER',
            associationId: user?.id,
          }}
        />
      ),
    }));
  }, [user?.id, creditAllocations]);

  if (!releasesSlides || releasesSlides.length === 0) {
    return null;
  }

  const subheader = formatProfileHeader({ count: releasesSlides?.length, text: 'Releases' });

  return (
    <CarouselWithHeader
      user={user}
      header="Appears On"
      subheader={subheader}
      slides={releasesSlides}
      path="/appears-on"
      seeAllParams={null}
    />
  );
};
